/* eslint-disable consistent-return */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, Tooltip } from '@mui/material';
import Alert from '@mui/material/Alert';
import { withStyles } from '@mui/styles';
import { makeStyles } from '@mui/styles';

import { useQuery } from '@apollo/client';
import * as Q from '../../../../../../constants/graphqlQueries';
import CustomDropdown from '../../../../../components/Dropdown/CustomDropdown';
import CustomTextField from '../../../../../components/Textfield/CustomTextField';
import CustomButtons from '../../../../../components/Button/CustomButtons';
import colors from '../../../../../../constants/colors';
import SwitchCustom from '../../../../../Switch/SwitchCustom';

import './Tagging.css';

const useStyles = makeStyles({
  alert: {
      fontSize: '1rem',
      color: colors.danger
  }
});
const optionsSwitch = {
  agent: {
    rightTitle: 'Agent'
  },
  GA: {
    rightTitle: 'G&A'
  },
  groupChat: {
    rightTitle: 'Group chat'
  }
};

const noZoomChannelsFoundMessage = 'There are no Zoom Channels available, Group Chat option is not available';

const flagFrequencyOptions = [
  { minutes: '5' },
  { minutes: '10' },
  { minutes: '15' },
  { minutes: 'No flagging' },
];
const flagFrequencyNoFlaggingOption = { minutes: '0' };
const agentValidationError = 'Notifications will only reach employees via Zoom, an existing TTEC email address is required.';
const ThresholdErrorMessages = {
  maximum: 'The Maximum value must be greater than the minimum',
  minimum: 'The Minimum value must be lower than the maximum',
  negative: 'Negative numbers are not a valid option',
  twentyFourHours: 'This value cannot exceed 24 hours (in minutes)'
};
const actionsOptions = [
  {id: 1, Description: 'Update'},
  {id: 2, Description: 'Delete'},
  {id: 3, Description: 'Replace'}
]
const MINIMUM = '0';
const MAXIMUM = '1440';

const TaggingWindowLimits = {
  Min: 0,
  Max: 24
}
const TaggingWindowLimitsErrorMessages = {
  Negative: 'Negative numbers are not a valid option',
  ExceededMaximum: 'This value cannot exceed 24 hours'
}

const StyledTooltip = withStyles({
  arrow: {
    color: '#F9F9F9'
  },
  tooltip: {
    backgroundColor: '#F9F9F9',
    color: colors.black,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.35)',
    padding: '1.3rem'
  }
})(Tooltip);

const generalIndexField = { Tag: 1, TagDuration: 2, MinimumThreshold: 3, MaximumThreshold: 4, FlagFrequency: 5, notes: 6, usersToBeNotified: 7 };
const FieldIndex = {
  EBL: generalIndexField,
  SOU: generalIndexField,
  SIU: { ...generalIndexField, TaggingWindow: 3 },
  BSL: generalIndexField,
  WOX: { Action: 1, Tag: 2, MinimumThreshold: 3, MaximumThreshold: 4, FlagFrequency: 5, notes: 6, usersToBeNotified: 7 }
}

const Tagging = ({
  taggingPreview, handleTaggingData, handleBack, alarmFound
}) => {
  const [inputFieldDisabled, setInputFieldDisabled] = useState(1);

  const classes = useStyles();
  const [tagOption, setTagOption] = useState({});
  const [tagSelected, setTagSelected] = useState();
  const [tagDuration, setTagDuration] = useState({});
  const [tagDurationSelected, setTagDurationSelected] = useState();
  const [taggingWindowSelected, setTaggingWindowSelected] = useState('');
  const [actions, setActions] = useState({});
  const [actionSelected, setActionSelected] = useState('');

  const [taggingWindowValidationError, setTaggingWindowValidationError] = useState({ state: false, message: '' });
  const [thresholdValidationError, setThresholdValidationError] = useState({ maximum: { state: false, message: '' }, minimum: { state: false, message: '' } });
  const [minimumThresholdSelected, setMinimumThresholdSelected] = useState('');
  const [maximumThresholdSelected, setMaximumThresholdSelected] = useState('');

  const [taggingWindowIsDisabled, setTaggingWindowIsDisabled] = useState(true);
  const [flagFrequency, setFlagFrequency] = useState({});
  const [flagFrequencySelected, setFlagFrequencySelected] = useState();
  const [selectedNotes, setSelectedNotes] = useState('');
  const [channels, setChannels] = useState({});
  const [selectedChannel, setSelectedChannel] = useState();

  const [isEditing, setIsEditing] = useState(false);

  // toggle states
  const [agentStatus, setAgentStatus] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [GAStatus, setGAStatus] = useState(false);
  const [selectedGA, setSelectedGA] = useState('');
  const [groupChatStatus, setGroupChatStatus] = useState(false);
  const [isNextButtonDisabled, setIsNextButtonDisabled] = useState(true);

  const { data: tagDurationData, loading: loadingTagDuration } = useQuery(Q.RULE__TAG__DURATION);
  const { data: ruleTagData, loading: loadingTag } = useQuery(Q.RULE__TAG);
  const { data: zoomChannelsData } = useQuery(Q.GET_ZOOM_CHANNELS);

  const cleanUpTagging = () => {
    setActionSelected(null);
    setTagSelected(null);
    setTagDurationSelected(null);
    setMinimumThresholdSelected('');
    setTaggingWindowSelected('');
    setMaximumThresholdSelected('');
    setFlagFrequencySelected(null);
    setSelectedNotes('');
    setAgentStatus(false);
    setGAStatus(false);
    setSelectedChannel();
    setGroupChatStatus(false);
  };

  // Rules Configuration tab navigation
  const handleNextPage = () => {
    const taggingDataToCreate = [{
      scheduleAlarmCode: alarmFound,
      tag: tagSelected?.ScheduleSegmentCode || null,
      tagKey: tagSelected?.ScheduleSegmentExternalKey || null,
      tagDuration: tagDurationSelected ? tagDurationSelected.Description : actionSelected.Description,
      taggingWindow: taggingWindowSelected,
      minimum: minimumThresholdSelected,
      maximum: maximumThresholdSelected,
      flagFrequency: flagFrequencySelected.minutes,
      notes: selectedNotes,
      notifyAgent: !agentStatus ? 0 : 1,
      agentNotification: selectedAgent,
      notifyGA: !GAStatus ? 0 : 1,
      GANotification: selectedGA,
      Channel: selectedChannel || null
    }];
    handleTaggingData(taggingDataToCreate);
  };

  const handleBackPage = (status) => {
    if (status === 'Cancel') {
      setActions({});
      cleanUpTagging();
      handleBack(status);
    }
    if (status === 'Back') handleBack();
  };

  // 'Tagging and Flagging' input handlers
  const handleActions = (item) => setActionSelected(item);

  const handleTagSelected = (item) => setTagSelected(item);

  const handleTagDuration = (item) => {
    if (isEditing && minimumThresholdSelected && maximumThresholdSelected && flagFrequencySelected) {
      if (flagFrequencySelected.minutes === flagFrequencyNoFlaggingOption.minutes) {
        setIsNextButtonDisabled(false);
      }
      else if ((agentStatus && selectedAgent) || (GAStatus && selectedGA)) {
        setIsNextButtonDisabled(false);
      }
    }

    setTagDurationSelected(item);
  };

  const handleTaggingWindow = (value) => setTaggingWindowSelected(value);

  // Thresholds
  const handleMinimum = (value) => {
    if (value) {
      if (value > Number(maximumThresholdSelected) && maximumThresholdSelected || value === '') {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, minimum: { state: true, message: value > Number(maximumThresholdSelected) && maximumThresholdSelected ? ThresholdErrorMessages.minimum : ''} });
      }
      else {
        const maximumErrorMessage = maximumThresholdSelected < 0 ? ThresholdErrorMessages.negative : maximumThresholdSelected > 1440 ? ThresholdErrorMessages.twentyFourHours : maximumThresholdSelected === '' ? '' : '';
        setThresholdValidationError({ maximum: { state: maximumErrorMessage ?? false, message: maximumErrorMessage }, minimum: { state: false, message: '' } });
      }

      // Cannot be negative nor exceed 24 hours limit
      if (value < 0 || value > 1440) {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, minimum: { state: true, message: value < 0 ? ThresholdErrorMessages.negative : ThresholdErrorMessages.twentyFourHours } });
      }
    }

    setMinimumThresholdSelected(value.replace(/^0+/, ''));
  };

  const handleMaximum = (value) => {
    if (value) {
      if (value < Number(minimumThresholdSelected) && minimumThresholdSelected || value === '') {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, maximum: { state: true, message: value < Number(minimumThresholdSelected) && minimumThresholdSelected ? ThresholdErrorMessages.maximum : ThresholdErrorMessages.isNull } });
      }
      else {
        const minimumErrorMessage = minimumThresholdSelected < 0 ? ThresholdErrorMessages.negative : minimumThresholdSelected > 1440 ? ThresholdErrorMessages.twentyFourHours : minimumThresholdSelected === '' ? ThresholdErrorMessages.isNull : '';
        setThresholdValidationError({ minimum: { state: minimumErrorMessage ?? false, message: minimumErrorMessage }, maximum: { state: false, message: '' } });
      }

      // Cannot be negative nor exceed 24 hours limit
      if (value < 0 || value > 1440) {
        // Show error
        setThresholdValidationError({ ...thresholdValidationError, maximum: { state: true, message: value < 0 ? ThresholdErrorMessages.negative : ThresholdErrorMessages.twentyFourHours } });
      }
    }
    setMaximumThresholdSelected(value.replace(/^0+/, ''));
  };

  // Flagging input
  const handleFlagFrequency = (item) => {
      if (item?.minutes === 'No flagging') setFlagFrequencySelected(flagFrequencyNoFlaggingOption);
      else setFlagFrequencySelected(item);
  };

  const handleToggleAgent = (checked) => {
    setAgentStatus(checked);
    if (!checked) {
      setSelectedAgent('');
    };
  };

  const handleNotificationAgent = (value) => setSelectedAgent(value);

  const handleToggleGA = (checked) => {
    setGAStatus(checked);
    if (!checked) {
      setSelectedGA('');
    };
  };

  const handleNotificationGA = (value) => setSelectedGA(value);

  const handleGroupChat = (checked) => {
    setGroupChatStatus(checked);
    if (!checked) {
      setSelectedChannel('');
    };
  }

  const handleChannel = (item) => {
    setSelectedChannel(item)
  }

  // Historical Notes
  const handleHistorical = (value) => setSelectedNotes(value);

  // Determine if input is disabled
  const isInputFieldDisabled = (inputIndex) => {
    let result = false;

    if (inputIndex > inputFieldDisabled && inputFieldDisabled) {
      result = true;
    }

    return result;
  }

  // Hooks
  useEffect(() => {
    if (alarmFound) {
      if (tagSelected && alarmFound === 'WOX') {
        if (actionSelected) {
          if (actionSelected.Description !== 'Replace') {
            setTagSelected(null);
          }
        }
      }
    }
  }, [tagSelected, alarmFound]);

  useEffect(() => {
    if (alarmFound) {
      if (actionSelected) {
        if (actionSelected.Description !== 'Replace') {
          setTagSelected(null);
        }
      }
    }
  }, [actionSelected, alarmFound]);

  useEffect(() => {
    if (ruleTagData) {
      const tagProps = {
        options: ruleTagData.scheduleSegment,
        getOptionLabel: (option) => option.ScheduleSegmentCode
      }
      setTagOption(tagProps);
    }
  }, [ruleTagData]);

  useEffect(() => {
    if (zoomChannelsData) {
      let channelProps = {
        options: [{ Name: 'No channels available' }],
        getOptionLabel: (option) => option.Name
      }

      if (zoomChannelsData.getZoomChannels.length) {
        channelProps = {
          options: zoomChannelsData.getZoomChannels,
          getOptionLabel: (option) => option.Name
        }
      }
      setChannels(channelProps);
    }
  }, [zoomChannelsData]);

  useEffect(() => {
    if (tagDurationData && alarmFound) {
      if (tagDurationData.tagDuration) {
        let tagDurationOptions = tagDurationData.tagDuration;

        if (alarmFound === 'SIU') {
          const SIUTagDurations = ['RealDuration', 'FixedDuration'];
          tagDurationOptions = tagDurationOptions.filter(tagDurationOption => SIUTagDurations.includes(tagDurationOption.Description));
        }
        else {
          const RegularTagDurations = ['RealDuration', 'AllDay'];
          tagDurationOptions = tagDurationOptions.filter(tagDurationOption => RegularTagDurations.includes(tagDurationOption.Description));
        }

        const tagDurationProps = {
          options: tagDurationOptions,
          getOptionLabel: (option) => `${option.Description}`
        }

        setTagDuration(tagDurationProps);
      }
    }
  }, [tagDurationData, alarmFound]);

  /** Begin Edit Flow */
  // The edit flow is triggered when taggingPreview prop is not empty
  useEffect(() => {
    if (taggingPreview.length && alarmFound && !loadingTag && !loadingTagDuration) {
      setInputFieldDisabled(null);
      if(taggingPreview[0].notes) setSelectedNotes(taggingPreview[0].notes);

      setFlagFrequencySelected({ minutes: String(taggingPreview[0].flagFrequency) });
      if (taggingPreview[0].notifyAgent === 1) {
        setAgentStatus(true);
        setSelectedAgent(taggingPreview[0].agentNotification || '')
      }

      if (taggingPreview[0].notifyGA === 1) {
        setGAStatus(true);
        setSelectedGA(taggingPreview[0].GANotification || '')
      }

      if (taggingPreview[0].editing) setIsEditing(true);
      setMinimumThresholdSelected(taggingPreview[0].minimum === 0 ? '0' : `${taggingPreview[0].minimum}`);
      setMaximumThresholdSelected(`${taggingPreview[0].maximum}`);

      if (alarmFound === 'WOX') {
        setTagDurationSelected(null);

        if (alarmFound === taggingPreview[0].scheduleAlarmCode) {
          setActionSelected({ Description: taggingPreview[0].tagDuration });

          if (taggingPreview[0].tagDuration === 'Replace') {
            setTagSelected({
              ScheduleSegmentCode: taggingPreview[0].tag,
              ScheduleSegmentExternalKey: taggingPreview[0].tagKey,
            });
          }
          else {
            setTagSelected(null);
          }
        }
        else {
          setTagDurationSelected('');
        }
      }
      else if (alarmFound !== 'WOX') {
        if (alarmFound === taggingPreview[0].scheduleAlarmCode) {
          setTagSelected({
            ScheduleSegmentCode: taggingPreview[0].tag,
            ScheduleSegmentExternalKey: taggingPreview[0].tagKey,
          });
          setTagDurationSelected({ Description: taggingPreview[0].tagDuration });

          if (alarmFound === 'SIU') {
            setTaggingWindowSelected(`${taggingPreview[0].taggingWindow}`);
          }
        }
        else {
          setTagDurationSelected('');
          setTaggingWindowSelected('');
        };
      };

      if (taggingPreview[0].Channel) {
        setGroupChatStatus(true);
        setSelectedChannel(taggingPreview[0].Channel);
      }
    }
  }, [taggingPreview, alarmFound, loadingTag, loadingTagDuration]);
  /** End Edit Flow */

  /** Begin load input options */
  useEffect(() => {
    const flagFrequencyProps = {
      options: flagFrequencyOptions,
      getOptionLabel: (option) => option.minutes
    };
    const actionsProps = {
      options: actionsOptions,
        getOptionLabel: (option) => option.Description
    };
    setFlagFrequency(flagFrequencyProps);
    setActions(actionsProps);
  }, []);

  /** End load input options */

  /** Input fields validation */
  useEffect(() => {
    if (alarmFound) {
      // Else if action not selected for WOX, set inputFieldDisabled equal to index of it
      if (!actionSelected && alarmFound === 'WOX') setInputFieldDisabled(FieldIndex[alarmFound].Action);
      // Else if tag not selected for non WOX or when action is 'Replace', set inputFieldDisabled equal to index of it
      else if (!tagSelected && (alarmFound !== 'WOX' || actionSelected.Description === 'Replace')) {
        setInputFieldDisabled(FieldIndex[alarmFound].Tag);
      }
      // Else if tagDuration not selected for non WOX, set inputFieldDisabled equal to the index of it
      else if (!tagDurationSelected && alarmFound !== 'WOX') setInputFieldDisabled(FieldIndex[alarmFound].TagDuration);
      else if ((!taggingWindowSelected || taggingWindowValidationError.state) && alarmFound === 'SIU' && tagDurationSelected.Description === 'FixedDuration') setInputFieldDisabled(FieldIndex[alarmFound].TaggingWindow);
      else if (!minimumThresholdSelected || thresholdValidationError.minimum.state) setInputFieldDisabled(FieldIndex[alarmFound].MinimumThreshold);
      else if (!maximumThresholdSelected || thresholdValidationError.maximum.state) setInputFieldDisabled(FieldIndex[alarmFound].MaximumThreshold);
      else if (!flagFrequencySelected) setInputFieldDisabled(FieldIndex[alarmFound].FlagFrequency);
      else if (agentStatus && selectedAgent === '' && flagFrequencySelected?.minutes !== '0') setInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified);
      else if (GAStatus && selectedGA === '' && flagFrequencySelected?.minutes !== '0') setInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified);
      else if (!GAStatus && !agentStatus && flagFrequencySelected?.minutes !== '0') setInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified);

      // If none of the above complied, then there are no input fields disabled and enable next button
      else setInputFieldDisabled(null);

      if (taggingWindowSelected && alarmFound === 'SIU' && tagDurationSelected === 'FixedDuration') {
        if (inputFieldDisabled === FieldIndex[alarmFound].TaggingWindow && !(taggingWindowValidationError.state)) {
          setInputFieldDisabled(null);
        }
      }

      if (maximumThresholdSelected && minimumThresholdSelected && !(thresholdValidationError.maximum.state) && !(thresholdValidationError.minimum.state)) {
        if (inputFieldDisabled === FieldIndex[alarmFound].MinimumThreshold || inputFieldDisabled === FieldIndex[alarmFound].MaximumThreshold) {
          setInputFieldDisabled(null);
        }
      }

      if (thresholdValidationError.minimum.state) {
        setInputFieldDisabled(FieldIndex[alarmFound].MaximumThreshold);
      }

      if (selectedChannel) {
        setInputFieldDisabled(null);
      }
    }
  }, [actionSelected, tagSelected, tagDurationSelected, minimumThresholdSelected, maximumThresholdSelected, flagFrequencySelected,
      alarmFound, thresholdValidationError, inputFieldDisabled, taggingWindowSelected, taggingWindowValidationError, GAStatus, 
      agentStatus, selectedAgent, selectedGA, selectedChannel]);

  useEffect(() => {
    if (inputFieldDisabled !== null) {
      setIsNextButtonDisabled(true);
    }
    else {
      setIsNextButtonDisabled(false);
    }
  }, [inputFieldDisabled]);

  useEffect(() => {
    if (tagDurationSelected) {
      if (tagDurationSelected.Description !== 'FixedDuration') {
        setTaggingWindowIsDisabled(true)
        setTaggingWindowSelected('');
      }
      else setTaggingWindowIsDisabled(false);
    }
  }, [tagDurationSelected]);

  useEffect(() => {
    if (taggingWindowSelected) {
      // Cannot be negative nor exceed 24 hours limit
      if (taggingWindowSelected < TaggingWindowLimits.Min || taggingWindowSelected > TaggingWindowLimits.Max) {
        // Show error
        setTaggingWindowValidationError({
          ...taggingWindowValidationError,
          state: true,
          message: taggingWindowSelected < 0 ? TaggingWindowLimitsErrorMessages.Negative : TaggingWindowLimitsErrorMessages.ExceededMaximum
        });
      }
      else setTaggingWindowValidationError({ state: false, message: '' });
    }
  }, [taggingWindowSelected]);

  useEffect(() => {
    if (flagFrequencySelected?.minutes === '0') {
        setAgentStatus(false);
        setGAStatus(false);
        setSelectedAgent('');
        setSelectedGA('');
    }
  }, [flagFrequencySelected]);

  return (
    alarmFound ?
    <>
      <div className='tagging__container'>
          <div className='tagging__container__box__first'> 
            <div className='box__tagging'>
              {alarmFound === 'WOX' &&
              <CustomDropdown
                title='Actions'
                value={actionSelected}
                handleChange={handleActions}
                defaultProps={actions}
                mandatory
              />}
              <CustomDropdown
                title='Tag'
                value={tagSelected}
                handleChange={handleTagSelected}
                defaultProps={tagOption}
                disabled={isInputFieldDisabled(FieldIndex[alarmFound].Tag) || (alarmFound === 'WOX' && actionSelected ? actionSelected.Description !== 'Replace' : false)}
                mandatory={(alarmFound === 'WOX' && actionSelected ? actionSelected.Description === 'Replace' : false) || alarmFound !== 'WOX'}
              />
              {alarmFound !== 'WOX' && 
              <CustomDropdown
                title='Tag Duration'
                value={tagDurationSelected}
                handleChange={handleTagDuration}
                defaultProps={tagDuration}
                disabled={isInputFieldDisabled(FieldIndex[alarmFound].TagDuration)}
                mandatory
              />
              }
              {(() => {
                if (alarmFound === 'SIU') {
                  return <>
                    <CustomTextField
                      title='Tagging Window (in hours)'
                      value={taggingWindowSelected}
                      handleChange={handleTaggingWindow}
                      placeholder='Input hours'
                      disabled={isInputFieldDisabled(FieldIndex[alarmFound].TaggingWindow) || taggingWindowIsDisabled}
                      type='number'
                      min={`${TaggingWindowLimits.Min}`}
                      max={`${TaggingWindowLimits.Max}`}
                      mandatory={tagDurationSelected ? tagDurationSelected.Description === 'FixedDuration' : false}
                    />
                    {
                      taggingWindowValidationError.state && <Alert
                        className={classes.alert}
                        severity='warning'>
                        {taggingWindowValidationError.message}
                      </Alert>
                    }
                    <CustomTextField
                      title='Minimum Threshold (in minutes)'
                      value={minimumThresholdSelected}
                      handleChange={handleMinimum}
                      placeholder='Input minutes'
                      disabled={isInputFieldDisabled(FieldIndex[alarmFound].MinimumThreshold)}
                      type='number'
                      min={MINIMUM}
                      max={MAXIMUM}
                      mandatory
                    />
                    {
                      thresholdValidationError.minimum.state && <Alert
                        className={classes.alert}
                        severity='warning'>
                        {thresholdValidationError.minimum.message}
                      </Alert>
                    }
                    <CustomTextField
                      title='Maximum Threshold (in minutes)'
                      value={maximumThresholdSelected}
                      handleChange={handleMaximum}
                      placeholder='Input minutes'
                      disabled={isInputFieldDisabled(FieldIndex[alarmFound].MaximumThreshold)}
                      type='number'
                      min={MINIMUM}
                      max={MAXIMUM}
                      mandatory
                    />
                    {
                      thresholdValidationError.maximum.state && <Alert
                        className={classes.alert}
                        severity='warning'>
                        {thresholdValidationError.maximum.message}
                      </Alert>
                    }
                  </>
                }

                return null;
              })()}
            </div>
            {(() => {
              if (alarmFound !== 'SIU') {
                return <div className='box__tagging'>
                  <CustomTextField
                    title='Minimum Threshold (in minutes)'
                    value={minimumThresholdSelected}
                    handleChange={handleMinimum}
                    placeholder='Input minutes'
                    disabled={isInputFieldDisabled(FieldIndex[alarmFound].MinimumThreshold)}
                    type='number'
                    min={MINIMUM}
                    max={MAXIMUM}
                    mandatory
                  />
                  {
                    thresholdValidationError.minimum.state && <Alert
                      className={classes.alert}
                      severity='warning'>
                      {thresholdValidationError.minimum.message}
                    </Alert>
                  }
                  <CustomTextField
                    title='Maximum Threshold (in minutes)'
                    value={maximumThresholdSelected}
                    handleChange={handleMaximum}
                    placeholder='Input minutes'
                    disabled={isInputFieldDisabled(FieldIndex[alarmFound].MaximumThreshold)}
                    type='number'
                    min={MINIMUM}
                    max={MAXIMUM}
                    mandatory
                  />
                  {
                    thresholdValidationError.maximum.state && <Alert
                      className={classes.alert}
                      severity='warning'>
                      {thresholdValidationError.maximum.message}
                    </Alert>
                  }
                </div>
              }

              return null;
            })()}
          <div className='box__tagging'>
            <CustomDropdown
              title='Flag Frequency (in minutes)'
              value={flagFrequencySelected}
              handleChange={handleFlagFrequency}
              defaultProps={flagFrequency}
              disabled={isInputFieldDisabled(FieldIndex[alarmFound].FlagFrequency)}
              mandatory
            />
          <p className='tagging__wrapper__autocomplete__title'>Users to be notified</p>
            <SwitchCustom
              switchStatus={agentStatus}
              options={optionsSwitch.agent}
              handleSwitch={handleToggleAgent}
              disabledStatus={isInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified)}
            />
            <Box style={{ display: !agentStatus ? 'none' : '' }}>
              <StyledTooltip title={agentValidationError}
                placement='top'
                enterDelay={400}
                leaveDelay={200}
                arrow
              >
                <div>
                  <CustomTextField
                    value={selectedAgent}
                    handleChange={handleNotificationAgent}
                    placeholder='Input text message'
                    multiline
                    rows={2}
                    maxLength={100}
                  />
                </div>
              </StyledTooltip>
            </Box>
            <SwitchCustom
              switchStatus={GAStatus}
              options={optionsSwitch.GA}
              handleSwitch={handleToggleGA}
              disabledStatus={isInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified)}
            />
            <Box style={{ display: !GAStatus ? 'none' : '' }}>
              <CustomTextField
                value={selectedGA}
                handleChange={handleNotificationGA}
                placeholder='Input text message'
                multiline
                rows={2}
                maxLength={100}
              />
            </Box>
            <SwitchCustom
              switchStatus={groupChatStatus}
              options={optionsSwitch.groupChat}
              handleSwitch={handleGroupChat}
              disabledStatus={isInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified) || !(zoomChannelsData && zoomChannelsData?.getZoomChannels.length)}
            />
            {
              !isInputFieldDisabled(FieldIndex[alarmFound].usersToBeNotified)
              && !(zoomChannelsData?.getZoomChannels.length) &&
              flagFrequencySelected?.minutes !== '0' &&
              <Alert
                className={classes.alert}
                severity='warning'>
                  {noZoomChannelsFoundMessage}
              </Alert>
            }
            <Box style={{ display: !groupChatStatus ? 'none' : '' }}>
              <CustomDropdown
                title='Channels'
                value={selectedChannel}
                handleChange={handleChannel}
                defaultProps={channels}
                disabled={!groupChatStatus}
              />
            </Box>
          </div>
          <div>
            <CustomTextField
              title='Notes'
              value={selectedNotes}
              handleChange={handleHistorical}
              placeholder='Input text message'
              multiline
              rows={2}
              maxLength={100}
              disabled={isInputFieldDisabled(FieldIndex[alarmFound].notes)}
            />
          </div>
        </div>
        <div className='tagging__container__box__second'>
          <div className='create__wrapper_btn'>
            <CustomButtons
              handleClick={() => handleBackPage('Cancel')}
              name='Cancel'
            />
            <CustomButtons
              handleClick={() => handleBackPage('Back')}
              name='Back'
            />
            <CustomButtons
              handleClick={handleNextPage}
              name='Next'
              disabled={isNextButtonDisabled}
              tooltipFree
            />
          </div>
      </div>
      </div>
    </> : <>...Loading</>
  );
};

Tagging.propTypes = {
  taggingPreview: PropTypes.array,
  handleTaggingData: PropTypes.func.isRequired,
  handleBack: PropTypes.func,
  alarmFound: PropTypes.string
};

Tagging.defaultProps = {
  taggingPreview: [],
  handleBack: null,
  alarmFound: null
};

export default Tagging;
